import {
    fetchLatestOrganizationAdIntegrationsSuccess,
    fetchLatestOrganizationIntegrationSuccess,
} from 'actions/auth'
import { getAdAccounts } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { getOrganizationIntegrations } from 'api/Cerebro/orgScoped/amazonIntegrationsApi'
import { cerebroApiRequestGuarded } from 'api/cerebroApiRequest'
import { selectDomainValue as selectAuthDomainValue } from 'selectors/auth'

import { getReduxState } from './reduxBridge'

type ShouldCommit = () => boolean

export async function fetchLatestActiveOrganizationIntegration(
    shouldCommit?: ShouldCommit
): Promise<void> {
    const organizationId: string = selectAuthDomainValue(
        getReduxState(),
        'organizationId'
    )

    await cerebroApiRequestGuarded(
        shouldCommit,
        fetchLatestOrganizationIntegrationSuccess,
        getOrganizationIntegrations,
        organizationId,
        {
            limit: 1,
            offset: 0,
            ordering: '-created_at',
            active: true,
        }
    )
}

export async function fetchLatestOrganizationAdIntegrations(
    shouldCommit?: ShouldCommit
): Promise<void> {
    const apiParams: any = {
        ordering: '-updated_date',
        type__in: 'seller,vendor',
    }

    await cerebroApiRequestGuarded(
        shouldCommit,
        fetchLatestOrganizationAdIntegrationsSuccess,
        getAdAccounts,
        apiParams
    )
}
